export const getCORSConfig = (
  token
) => token ? {
  headers: {
    authorization: `Bearer ${token}`
  },
  mode: 'cors'
} : {
  mode: 'cors'
}